export default __webpack_public_path__ + "static/Earth-Day-Homepage-Banner-Mobile-81aea9eed3216116ca86c4aba3bcc81c.webp";